<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.details" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </div>
      <template #extra>
        <vxe-button :disabled="!order.isNew()" content="button.reset" icon="vxe-icon-undo" mode="text" status="danger" @click="clear"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.addDetail" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
        <vxe-button :disabled="order.orderStatus>0" content="button.submit" icon="vxe-icon-signature" mode="text" status="primary" @click="submit"/>
        <!--          <a-upload :multiple="true" name="file">-->
        <!--            <a-button type="primary" @click="importExcel">-->
        <!--              <a-icon type="upload" />-->
        <!--              {{ $t('button.impConfirm') }}-->
        <!--            </a-button>-->
        <!--          </a-upload>-->
      </template>
      <a-form-model :colon="false" :label-col="labelCol" :model="order" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderNo')" prop="no">
              <a-input v-model="order.no" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.orderType')" prop="orderType">
              <a-input-search v-model="order.orderType.name" :disabled="order.orderStatus>0" readOnly @dblclick="onOrderTypeSelect" @pressEnter="onOrderTypeSelect" @search="onOrderTypeSelect"/>
              <order-type-modal ref="orderTypeModal" @change="onOrderTypeChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storer')" prop="storer">
              <a-select v-model="order.storer.id" :disabled="order.orderStatus>0" :options="storers" @change="onStorerChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.supplier')" prop="supplier">
              <a-input-search v-model="order.supplier.name" :disabled="order.orderStatus>0" allowClear readOnly @dblclick="onSupplierSelect" @pressEnter="onSupplierSelect" @search="onSupplierSelect"/>
              <customer-modal ref="customerModal" @change="onSupplierChange"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.maker')" prop="operator">
              <a-input v-model="order.operator" disabled/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.buyer')" prop="buyer">
              <a-input-search v-model="order.buyer" :disabled="order.orderStatus>0" allowClear readOnly @dblclick="onBuyerSelect" @pressEnter="onBuyerSelect" @search="onBuyerSelect"/>
              <user-modal ref="userModal" @change="onBuyerChange"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <vxe-table
      ref="table"
      :data="order.details"
      :edit-config="{ trigger: order.orderStatus>0?'manual':'click', mode: 'row', showStatus: true }"
      :edit-rules="editRules"
      :export-config="{}"
      :height="height"
      :keyboard-config="{isArrow: true}"
      :loading="loading"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :scroll-x="{enabled: true}"
      align="center"
      border
      keep-source
      round
      show-header-overflow
      show-overflow
      size="mini"
      stripe>
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="itemRender" field="item.no" title="business.label.itemNo" width="100"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column :edit-render="packRender" field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column :edit-render="lotRender" field="lotNo" title="business.label.lot" width="120"/>
      <vxe-column :edit-render="dateRender" field="productionDate" title="business.label.productionDate" width="120"/>
      <vxe-column :edit-render="dateRender" field="validUntil" title="business.label.validUntil" width="120"/>
      <vxe-column :edit-render="textRender" field="manufacturer" title="business.label.manufacturer" width="200"/>
      <vxe-column :edit-render="textRender" field="producingArea" title="business.label.producingArea" width="120"/>
      <vxe-column :edit-render="textRender" field="approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column :edit-render="numberRender" field="plannedQuantity" title="business.label.plannedQuantity" width="150"/>
      <vxe-column :edit-render="numberRender" field="price" title="business.label.price" width="120"/>
      <vxe-column fixed="right" title="business.label.operate" width="auto">
        <vxe-button-group slot-scope="{row}" mode="text">
          <vxe-button :disabled="order.orderStatus>0" content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
        </vxe-button-group>
      </vxe-column>
    </vxe-table>
    <item-modal ref="itemModal" @change="onItemChange"/>
    <pack-modal ref="packModal" @change="onPackChange"/>
    <lot-modal ref="lotModal" @change="onLotChange"/>
  </div>
</template>
<script>
import Vue from 'vue'
import Api from '@/api'
import { deleteOne, findAll, post } from '@/api/Api'
import moment from 'moment'
import { OPERATOR, SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import UserModal from '@/views/modal/UserModal.vue'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import ItemModal from '@/views/modal/ItemModal.vue'
import PackModal from '@/views/modal/PackModal.vue'
import LotModal from '@/views/modal/LotModal.vue'
import { BaseObject } from '@/api/dto/BaseObject'
import { PurchaseDetail, PurchaseOrder } from '@/api/dto/order/PurchaseOrder'
import { OrderType } from '@/api/dto/common/OrderType'
import { Customer } from '@/api/dto/common/Customer'
import { Item } from '@/api/dto/common/Item'
import { Pack } from '@/api/dto/common/Pack'

export default {
  name: 'PurchaseOrderDetail',
  components: { OrderTypeModal, LotModal, ItemModal, PackModal, UserModal, CustomerModal },
  data() {
    return {
      loading: false,
      operator: Vue.ls.get(OPERATOR),
      warehouse: Vue.ls.get(WAREHOUSE),
      order: new PurchaseOrder(),
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.75),
      currentStorerId: null,
      rules: {
        orderType: [{ required: true }],
        storer: [{ required: true }],
        supplier: [{ required: true }]
      },
      editRules: {
        'item.no': [
          { required: true, message: '商品编号不能为空' }
        ],
        'item.name': [
          { required: true, message: '商品名称不能为空' }
        ],
        'pack.specification': [
          { required: true, message: '包装规格不能为空' }
        ],
        'plannedQuantity': [
          { required: true, min: 1, type: 'number', message: '计划数量需大于0' }
        ]
      },
      textRender: {
        name: 'VxeInput',
        autoFocus: true,
        autoSelect: true,
        props: {
          clearable: true
        }
      },
      numberRender: {
        name: 'VxeNumberInput',
        autoFocus: true,
        autoSelect: true,
        props: {
          clearable: true,
          min: 0
        }
      },
      dateRender: {
        name: 'VxeDatePicker',
        autoFocus: true,
        autoSelect: true,
        props: {
          clearable: true
        }
      },
      itemRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        props: {
          clearable: true
        },
        events: {
          click: ({ row }) => this.onItemSelect(row),
          clear: ({ row }) => {
            row.item = new Item()
            row.pack = new Pack()
            row.lotNo = ''
            row.productionDate = ''
            row.validUntil = ''
            row.manufacturer = ''
            row.producingArea = ''
            row.approvalNo = ''
          }
        }
      },
      packRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        props: {
          clearable: true
        },
        events: {
          click: ({ row }) => this.onPackSelect(row),
          clear: ({ row }) => row.pack = new Pack()
        }
      },
      lotRender: {
        name: 'VxeInput',
        placeholder: '点击选择',
        props: {
          clearable: true
        },
        events: {
          click: ({ row }) => this.onLotSelect(row),
          clear: ({ row }) => {
            row.lotNo = ''
            row.productionDate = ''
            row.validUntil = ''
            row.manufacturer = ''
            row.producingArea = ''
            row.approvalNo = ''
          }
        }
      }
    }
  },
  created() {
    this.order.operator = this.operator.name
    this.order.buyer = this.operator.name
  },
  props: {
    storers: {
      type: Array,
      default: []
    }
  },
  methods: {
    moment,
    back() {
      this.$emit('back')
    },
    fetch(row) {
      this.order = new PurchaseOrder(BaseObject.merge(row, 'order'))
      this.getDetails()
    },
    getDetails() {
      if (this.order.isNew()) return
      this.loading = true
      findAll('purchaseDetailFactory', { 'order.id': this.order.id }).then(res => {
        if (res.success) {
          this.order.details = res.result.map(item => {
            return new PurchaseDetail(BaseObject.merge(item, 'purchaseDetail'))
          })
        }
      }).finally(() => this.loading = false)
    },
    onOrderTypeSelect() {
      this.$refs.orderTypeModal.open({ available: true, operationType: 1, refundable: false })
    },
    onOrderTypeChange(data) {
      this.order.orderType = new OrderType(data[0])
    },
    onStorerChange() {
      if (this.currentStorerId !== null && this.currentStorerId !== this.order.storer.id) {
        this.clear()
      }
      this.currentStorerId = this.order.storer.id
    },
    onSupplierSelect() {
      if (this.checkStorer()) {
        this.$refs.customerModal.open({ available: true, 'storer.id': this.order.storer.id, upstream: true })
      }
    },
    onSupplierChange(data) {
      this.order.supplier = new Customer(data[0])
    },
    onBuyerSelect() {
      this.$refs.userModal.open({ available: true })
    },
    onBuyerChange(data) {
      this.order.buyer = data.length > 0 ? data[0].name : ''
    },
    onItemSelect(row) {
      if (this.checkStorer()) {
        this.$refs.itemModal.open({ 'storer.id': this.order.storer.id }, row)
      }
    },
    onItemChange(data, row) {
      row.item = new Item(data[0])
      row.pack = new Pack()
      this.onLotChange([], row)
    },
    onPackSelect(row) {
      if (this.checkItem(row)) {
        this.$refs.packModal.open({ 'item.id': row.item.id }, row)
      }
    },
    onPackChange(data, row) {
      row.pack = new Pack(data[0])
    },
    onLotSelect(row) {
      if (this.checkItem(row)) {
        this.$refs.lotModal.open({ 'item.id': row.item.id }, row)
      }
    },
    onLotChange(data, row) {
      if (data.length > 0) {
        let lot = data[0]
        row.lotNo = lot.no
        row.productionDate = lot.productionDate
        row.validUntil = lot.validUntil
        row.manufacturer = lot.manufacturer
        row.producingArea = lot.producingArea
        row.approvalNo = lot.approvalNo
      } else {
        row.lotNo = ''
        row.productionDate = ''
        row.validUntil = ''
        row.manufacturer = ''
        row.producingArea = ''
        row.approvalNo = ''
      }
    },
    checkStorer() {
      if (this.order.storer.isNew()) {
        this.$warning({ title: '请先选择货主', centered: true })
        return false
      }
      return true
    },
    checkItem(row) {
      if (row.item.isNew()) {
        this.$warning({ title: '请先选择商品', centered: true })
        return false
      }
      return true
    },
    verify() {
      if (this.order.orderType.isNew()) {
        this.$warning({ title: '请选择订单类型', centered: true })
        return false
      }
      if (this.order.storer.isNew()) {
        this.$warning({ title: '请选择货主', centered: true })
        return false
      }
      if (this.order.supplier.isNew()) {
        this.$warning({ title: '请选择供应商', centered: true })
        return false
      }
      if (this.order.details.length === 0) {
        this.$warning({ title: '请添加明细', centered: true })
        return false
      }
      return true
    },
    reset() {
      this.order = new PurchaseOrder()
      this.order.orderStatus = 0
      this.order.operator = this.operator.name
      this.order.buyer = this.operator.name
    },
    clear() {
      let that = this
      that.$confirm({
        title: '将清空界面数据',
        content: '是否确定',
        onOk() {
          that.reset()
        },
        onCancel() {
        },
        centered: true
      })
    },
    add() {
      this.order.details.push(new PurchaseDetail())
    },
    async save() {
      let pass = this.verify()
      if (!pass) {
        return
      }
      const table = this.$refs.table
      const errMap = await table.validate(true)
      if (!errMap) {
        this.loading = true
        let order = this.order.toJSONObject()
        order.warehouse = this.warehouse
        order.details = this.order.details.map(dtl => dtl.toJSONObject())
        post(Api.buyingSave, { type: 'omsPlan' }, order).then(res => {
          if (res.success) {
            this.$success({ title: '保存成功', centered: true })
            this.order = new PurchaseOrder(res.result)
            this.getDetails()
          }
        }).finally(() => this.loading = false)
      }
    },
    async submit() {
      await this.save()
      this.loading = true
      post(Api.buyingSubmit, { type: 'omsPlan' }, { id: this.order.id }).then(res => {
        if (res.success) {
          this.$success({ title: '提交成功', centered: true })
          this.order = new PurchaseOrder(res.result)
          this.getDetails()
        }
      }).finally(() => this.loading = false)
    },
    exportExcel() {
      this.$refs.table.openExport()
    },
    importExcel() {

    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('purchaseDetailDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.$message.success(this.$t('message.deleteSuccess'))
            this.fetch()
          }
        }).finally(() => this.loading = false)
      } else {
        this.order.details.splice(this.order.details.indexOf(row), 1)
      }
    }
  }
}
</script>